import { z } from "zod";

export const doctorRoles = z.enum(["recommendingDoctor", "issuingDoctor"]);

export const doctorSchema = z.object({
	id: z.string().nonempty(),
	email: z.string().email(),
	firstName: z.string().nonempty(),
	lastName: z.string().nonempty(),
	phone: z.string().optional(),
	roles: z.array(doctorRoles).min(1),
	hasOnlineSubmission: z.boolean(),
	signatureUrl: z
		.string()
		.url()
		.refine(
			(u) => {
				try {
					const url = new URL(u);
					return url.protocol === "https:" && url.hostname === "firebasestorage.googleapis.com";
				} catch {
					return false;
				}
			},
			{ message: "signatureUrl must be an HTTPS Firebase Storage URL" }
		)
		.optional(),
	signaturePath: z
		.string()
		.regex(
			/^doctors\/[a-zA-Z0-9_\-]+\/signature\.(png|jpg|jpeg|webp)$/,
			{ message: "signaturePath must match doctors/{id}/signature.{ext}" }
		)
		.optional(),
	signatureUploadedAt: z.number().optional(),
});

export const newDoctorSchema = doctorSchema.omit({
	id: true,
});

export type TDoctor = z.infer<typeof doctorSchema>;
export type TDoctorRoles = z.infer<typeof doctorRoles>;
export type TNewDoctor = z.infer<typeof newDoctorSchema>;
